// URL validation utilities for callback URLs and other URL fields

export const URL_REGEX = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;

export const validateUrl = (url: string): boolean => {
  if (!url) return true; // Empty is valid for optional fields

  try {
    const urlObj = new URL(url);
    // Ensure it's http or https
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
  } catch {
    return false;
  }
};

export const getUrlError = (url: string, fieldName: string = 'URL', required: boolean = false): string | null => {
  // If field is empty
  if (!url || url.trim() === '') {
    if (required) {
      return `${fieldName} is required`;
    }
    return null; // Empty is valid for optional fields
  }

  // Check if it's a valid URL
  if (!validateUrl(url)) {
    return `Invalid ${fieldName} format. Must be a valid HTTP or HTTPS URL (e.g., https://example.com/webhook)`;
  }

  // Check protocol
  try {
    const urlObj = new URL(url);
    if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
      return `${fieldName} must use HTTP or HTTPS protocol`;
    }
  } catch {
    return `Invalid ${fieldName} format`;
  }

  return null;
};

// Helper function to ensure URL has protocol
export const ensureProtocol = (url: string): string => {
  if (!url) return url;

  const trimmed = url.trim();
  if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
    return `https://${trimmed}`;
  }

  return trimmed;
};
